export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.536 3.695h5.162l.157.013a1 1 0 01.787.66l.943 2.714a3 3 0 001.822 1.84l2.896 1.037 2.582.747a5.51 5.51 0 013.96 4.817c.401.365.655.89.655 1.477v2a2 2 0 01-2 2h-17a2 2 0 01-2-2v-2c0-.507.19-.969.5-1.321V4.999L.704 3.055l1.665-1.11 1.167 1.75zM3.5 19h17v-2h-17v2zm.5-4h9.668a6.05 6.05 0 01-.156-1.26c0-.611.143-1.409.265-1.991.014-.067.03-.133.044-.196l-2.09-.748a5 5 0 01-3.035-3.067l-.71-2.043H4V15zm11.733-2.834c-.121.58-.22 1.192-.22 1.573 0 .36.093.823.207 1.237l.008.024h3.99a3.508 3.508 0 00-2.388-2.372l-1.597-.462z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};